import { render, staticRenderFns } from "./DespesaInfo.vue?vue&type=template&id=3c4966bc"
import script from "./DespesaInfo.vue?vue&type=script&lang=js"
export * from "./DespesaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports